/* eslint-disable react/no-did-mount-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as browserCheck from '../../utils/browserCheck.js';

class CookieMessage extends Component {
    constructor(props, context) {
        super(props, context);        
        this.state = { 
            cookieConsented: true
        };
        this.dismiss = this.dismiss.bind(this);
    }

    componentDidMount() {
        if(browserCheck.canUseDom()) {
            this.setState({
                cookieConsented: localStorage.getItem('cookie_eu_consented') ? true : false
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.cookieConsented != nextState.cookieConsented;
    }

    dismiss(e) {
        e.preventDefault();    
        if(browserCheck.canUseDom()) {
            localStorage.setItem("cookie_eu_consented", true);
        }        
        this.setState({cookieConsented: true});   
    }

    render() {        
        const cookieConsented = this.state.cookieConsented;
        const canUseDom = browserCheck.canUseDom();
        return (
            !cookieConsented || !canUseDom ?
                <div id="cookies-eu" className="cookies-eu" style={{display: canUseDom ? 'inline' : 'none'}}>
                    <span className="cookies-eu-content-holder">This website uses cookies to improve the user experience. By using this website, you consent to all cookies in accordance with our cookie policy</span>
                    <span className="cookies-eu-button-holder">
                        <button className="cookies-eu-ok" onClick={this.dismiss}>OK</button>
                        <Link to="/CookiePolicy" className="cookies-eu-link">Learn more</Link>
                    </span>
                </div>
            : null
        );
    }
}

CookieMessage.propTypes = {
    //addAnimation: PropTypes.func.isRequired
};

export default CookieMessage;
